import { useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import { Search } from "lucide-react";

export default function AirportPicker({ value, onChange, testId = "airport-picker" }) {
  const [airports, setAirports] = useState([]);
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    api.get("/airports").then((r) => setAirports(r.data)).catch(() => {});
  }, []);

  const filtered = useMemo(() => {
    if (!q) return airports.slice(0, 8);
    const s = q.toLowerCase();
    return airports.filter(a =>
      a.name.toLowerCase().includes(s) ||
      a.city.toLowerCase().includes(s) ||
      a.iata_code.toLowerCase().includes(s)
    ).slice(0, 10);
  }, [q, airports]);

  const selected = airports.find(a => a.iata_code === value);

  return (
    <div className="relative">
      <label className="text-[11px] font-bold tracking-[0.18em] uppercase text-slate-500">Airport</label>
      <div className="mt-1 flex items-center gap-2 border-b border-slate-200 focus-within:border-[var(--fpn-navy)] py-2">
        <Search size={16} className="text-slate-400" />
        <input
          data-testid={`${testId}-input`}
          value={q || (selected ? `${selected.name} (${selected.iata_code})` : "")}
          onChange={(e) => { setQ(e.target.value); setOpen(true); }}
          onFocus={() => setOpen(true)}
          onBlur={() => setTimeout(() => setOpen(false), 180)}
          placeholder="Airport, city or IATA (e.g. LHR)"
          className="w-full bg-transparent outline-none text-sm placeholder:text-slate-400"
        />
      </div>
      {open && filtered.length > 0 && (
        <div className="absolute z-30 mt-2 w-full bg-white border border-slate-200 rounded-xl shadow-xl overflow-hidden" data-testid={`${testId}-options`}>
          {filtered.map((a) => (
            <button
              type="button"
              key={a.iata_code}
              className="w-full text-left px-4 py-3 hover:bg-slate-50 flex items-center justify-between"
              onMouseDown={() => { onChange(a.iata_code); setQ(""); setOpen(false); }}
              data-testid={`airport-option-${a.iata_code}`}
            >
              <div>
                <div className="text-sm font-medium text-slate-900">{a.name}</div>
                <div className="text-xs text-slate-500">{a.city}, {a.country}</div>
              </div>
              <div className="text-xs font-bold tracking-widest text-[var(--fpn-navy)]">{a.iata_code}</div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
